<template>
  <div>
    <div class="w-100pct h-60px bg-cl-black cl-white f-s-18px f-w-bold pd-18px">
      <router-link :to="{ name: 'Home' }">
        <svg-filler class="mg-r-auto f-left cs-pointer" path="/static/svg/back.svg" :fill="'#ffffff'" width="20px" height="20px"/>
      </router-link>
      <span>
        ข้อมูลของฉัน
      </span>
    </div>
    <div class="w-100pct h-60calc">
      <div class="t-al-center">
        <img src="/static/img/image/sellsuki.PNG" style="width:228px;">
      </div>
      <div class="t-al-center f-s-18px f-w-bold">
        {{ userInfo.user.first_name }}  {{ userInfo.user.last_name }}
      </div>
        <table class="table t-al-center f-s-18px mg-auto pd-hrzt-10px">
          <tr>
            <td>
              EmpNo.
            </td>
            <td>
              {{ userInfo.user.id }}
            </td>
          </tr>
          <tr>
            <td>
              Branch name
            </td>
            <td>
              {{ userInfo.user.branch_name }}
            </td>
          </tr>
          <tr>
            <td>
              POS ID
            </td>
            <td>
              {{ userInfo.user.pos_id }}
            </td>
          </tr>
          <tr>
            <td>
              E-mail
            </td>
            <td>
              {{ userInfo.user.email }}
            </td>
          </tr>
        </table>
      <div class="t-al-center mg-t-16px">
        <router-link :to="{ name: 'ReportZ' }" exact>
          <div class="reportZ-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px cl-white"> รายงานสรุปยอดประจำวัน </div>
        </router-link>
      </div>
      <div class="t-al-center mg-t-16px">
        <div class="reportZ-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px cl-white" @click="changeBranch()"> เปลี่ยนสาขา </div>
      </div>
      <div class="t-al-center mg-t-21px">
        <div class="logOut-btn cs-pointer mg-auto pd-vtc-5px pd-hrzt-2px" @click="logout()"> ออกจากระบบ </div>
      </div>
    </div>
    <b-modal :active.sync="activeModal" :canCancel="[]" @close="getBranchNameDisplay()">
      <selectStore :cancelBtn="true"/>
    </b-modal>
  </div>
</template>

<script>
import selectStore from '@/views/selectStore'
import { mapActions } from 'vuex'
import { getSellsukiUser, getBranchName, getPOSID } from '@/utils/helper/localStorage'
export default {
  name: 'user-info',
  data () {
    return {
      sellsukiVersion: window.sellsukiVersion,
      activeModal: false,
      userInfo: {
        user: {
          id: '',
          first_name: '',
          last_name: '',
          username: '',
          branch_name: '',
          pos_id: ''
        }
      }
    }
  },
  methods: {
    back () {
      this.$router.push({path: '/'})
    },
    logout () {
      this.$dialog.confirm({
        title: 'ยืนยันการออกจากระบบ',
        message: '<center>คุณต้องการออกจากระบบใช่หรือไม่ ?</center>',
        cancelText: 'ไม่ใช่',
        confirmText: 'ใช่',
        onConfirm: () => {
          this.setSellsukiAuth('')
          window.localStorage.removeItem('currentBranchPOS')
          window.location.href = process.env.SELLSUKI_LOGOUT_PORTAL
        }
      })
    },
    ...mapActions([
      'setSellsukiAuth'
    ]),
    changeBranch () {
      this.activeModal = true
    },
    getBranchNameDisplay () {
      this.userInfo.user.branch_name = getBranchName()
      this.userInfo.user.pos_id = getPOSID()
    }
  },
  components: {
    selectStore
  },
  async mounted () {
    this.userInfo = await getSellsukiUser()
    this.getBranchNameDisplay()
  }
}
</script>

<style scoped>
.reportZ-btn {
  width: 210px;
  height: 36px;
  border-radius: 4px;
  background-color: #000000;
  border: solid 0.5px #e5e5e5;
}
.logOut-btn {
  width: 210px;
  height: 36px;
  border-radius: 4px;
  background-color: #ffffff;
  border: solid 1px #000000;
}
</style>



// WEBPACK FOOTER //
// src/views/user-info/UserInfo.vue